const DEFAULT_SHIFTS_PER_PLAN = 15;

const resolveShiftsPerPlan = (value) => {
  const num = Number(value);
  return Number.isFinite(num) && num > 0 ? num : DEFAULT_SHIFTS_PER_PLAN;
};

/**
 * Определяет номер уровня сотрудника (1..N) по диапазонам EmployeePlan,
 * итоговым баллам и количеству отработанных дней.
 *
 * Диапазоны plan.from/plan.to калиброваны на shiftsPerPlan смен.
 */
export default function computeEmployeeLevel(
  employeePlans,
  totalPoints,
  workedDays,
  shiftsPerPlan = DEFAULT_SHIFTS_PER_PLAN,
) {
  const days = Number(workedDays);
  if (!days || days <= 0) {
    return null;
  }

  const shifts = resolveShiftsPerPlan(shiftsPerPlan);

  const plans = [...(employeePlans || [])].sort(
    (a, b) => (Number(a.sort) || 0) - (Number(b.sort) || 0),
  );

  if (plans.length === 0) {
    return null;
  }

  const value = (Number(totalPoints) || 0) / days;

  const matchingIndex = plans.findIndex((plan) => {
    const from = (Number(plan.from) || 0) / shifts;
    const to = (Number(plan.to) || 0) / shifts;
    return value >= from && value <= to;
  });

  if (matchingIndex >= 0) {
    return matchingIndex + 1;
  }

  const lastTo = (Number(plans[plans.length - 1].to) || 0) / shifts;
  if (value > lastTo) {
    return plans.length;
  }

  return null;
}
